import { createFeatureSelector, createSelector } from '@ngrx/store';
import { supplierFeatureKey, SupplierState } from './supplier-reducer';

export const getFilterSupplierState =
  createFeatureSelector<SupplierState>(supplierFeatureKey);

export const getSupplierState = createSelector(
  getFilterSupplierState,
  (state: SupplierState) => state
);
